<template>
  <div>
    <el-select
      v-model="selected"
      multiple
      filterable
      @change="emitEvent(selected)"
      :placeholder="'Seleccione términos para el atributo '+ attribute.title">
      <el-option
        v-for="item in terms"
        :key="item.id"
        :label="item.value_admin"
        :value="item.id">
      </el-option>
    </el-select>
    <el-button type="primary" size="small" class="mt-10" plain @click="selectAll">Seleccionar todos</el-button>
    <el-button type="default" size="small" class="mt-10" plain @click="selected=[];emitEvent(null)">Borrar selección</el-button>
  </div>
</template>

<script>
import { edit } from '@/api/administration/adminTable.js'
export default {
  data(){
    return {
      selected: [],
      terms: [],
    }
  },
  props: ['attribute'],
  created(){
    this.getTerms()
  },
  methods:{
    async getTerms(){ 
      let data = await edit(this.attribute.id)
      this.terms = data.data.terms
    },
    async selectAll(){
      let array = []
      await this.terms.forEach(element => {
        array.push(element.id)
      });
      this.selected = array
      this.emitEvent(this.selected)
    },
    emitEvent(selected){
      this.$emit('changeTerms', this.attribute, selected)
    }
  }
}
</script>